function translateService($translate, _) {
  const translate = {};

  translate.key = (value, prefix) => {
    const val = value.toUpperCase();
    return $translate.instant(`${prefix}_${val.replace(/\t|\s/g, '_')}`);
  };

  translate.keyArray = (array, property, prefix) => {
    if (!property) return _.map(array, item => translate.key(item, prefix));

    return _.each(array, (currentItem) => {
      const item = currentItem;
      item[property] = translate.key(item[property], prefix);
    });
  };

  return translate;
}

const arr = [
  '$translate',
  '_',
  translateService
];

module.exports = (ngModule) => {
  ngModule.service('translateService', arr);
};
